import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import { GoogleOAuthProvider } from "@react-oauth/google";
import ScrollToTop from "./components/ui/ScrollToTop";
import Navbar from "./components/Navbar";
import Footer from "./components/Footer";
import MyMemberships from "./components/MyMemberships";

import Home from "./pages/Home";
import About from "./pages/About";
import Events from "./pages/Events";
import GalleryPage from "./pages/GalleryPage";
import Contact from "./pages/Contact";
import MembershipInfo from "./pages/MembershipInfo";
import MembershipDashboard from "./pages/MembershipDashboard";
import MembershipForm from "./pages/MembershipForm";
import Login from "./pages/Login";
import Signup from "./pages/Signup";
import Profile from "./pages/Profile";

import PaymentSuccess from "./pages/PaymentSuccess";
import PaymentCancel from "./pages/PaymentCancel";

import OurTeam from "./components/OurTeam";

const googleClientId = process.env.REACT_APP_GOOGLE_CLIENT_ID || "";
//console.log("Google Client ID:", googleClientId);

export default function App() {
  return (
    <GoogleOAuthProvider clientId={googleClientId}>
      <Router>
        <ScrollToTop />
        <Navbar />

        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/about" element={<About />} />
          <Route path="/events" element={<Events />} />
          <Route path="/gallerypage" element={<GalleryPage />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/profile" element={<Profile />} />
          <Route path="/membershipinfo" element={<MembershipInfo />} />
          <Route path="/membershipdashboard" element={<MembershipDashboard />} />
          <Route path="/membershipform" element={<MembershipForm />} />
          <Route path="/mymemberships" element={<MyMemberships />} />
          <Route path="/payment-success" element={<PaymentSuccess />} />
          <Route path="/payment-cancel" element={<PaymentCancel />} />
          <Route path="/signup" element={<Signup />} />
          <Route path="/login" element={<Login />} />
          <Route path="/ourteam" element={<OurTeam />} />
        </Routes>

        <Footer />
      </Router>
    </GoogleOAuthProvider>
  );
}